// for undercity / dalaran side
export const VIEW_DEFAULT_WIDTH = 400;
export const VIEW_POST_DETAIL_WIDTH = 600;
